// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const PrintRegistrationFormModal = t.struct({
    isVisible: t.Boolean,
    registrationId: t.String,
    route: t.String
}, 'PrintRegistrationFormModal');

export const getDefaultState = () =>
    new PrintRegistrationFormModal({
        isVisible: false,
        registrationId: '',
        route: '#'
    });

export default PrintRegistrationFormModal;



// WEBPACK FOOTER //
// ./src/product/product-registration/state/print-registration-form-modal.js